import intl from 'react-intl-universal';
import nl from './nl.json';

export const locales = {
  nl,
};

export const defaultLocale = 'nl';

export const getLocale = () => localStorage.getItem('locale') || defaultLocale;

export const getTranslation = (key: string, variables?: any) => {
  return intl.get(key, variables).defaultMessage(`??? ${key} [${getLocale()}] ???`);
};

export const getTranslationHtml = (key: string, variables?: any) => {
  return intl.getHTML(key, variables).defaultMessage(`??? ${key} [${getLocale()}] ???`);
};
